import { Check } from "lucide-react";

export const inputClass =
  "w-full min-h-[48px] rounded-md border border-slate-300 bg-white px-3.5 py-2.5 text-base text-slate-900 shadow-sm outline-none transition-colors placeholder:text-slate-400 focus:border-[#C8102E] focus:ring-2 focus:ring-[#C8102E]/20 sm:min-h-[44px] sm:text-sm";
const labelClass = "block text-sm font-semibold text-slate-800";

export function Field({ label, hint, children }) {
  return (
    <div className="space-y-1.5">
      <label className={labelClass}>{label}</label>
      {children}
      {hint && <p className="text-xs text-slate-500">{hint}</p>}
    </div>
  );
}

export function CheckRow({ checked, onChange, label, testId }) {
  return (
    <label className="flex min-h-[48px] cursor-pointer items-start gap-3 rounded-lg border border-slate-200 bg-white p-3.5 transition-colors hover:border-slate-300">
      <button
        type="button"
        role="checkbox"
        aria-checked={checked}
        data-testid={testId}
        onClick={() => onChange(!checked)}
        className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded border transition-colors ${
          checked ? "border-[#C8102E] bg-[#C8102E] text-white" : "border-slate-300 bg-white"
        }`}
      >
        {checked && <Check className="h-3.5 w-3.5" strokeWidth={3} />}
      </button>
      <span className="text-sm font-medium text-slate-700">{label}</span>
    </label>
  );
}

export function SectionTitle({ icon: Icon, title }) {
  return (
    <div className="flex items-center gap-3 border-b border-slate-100 pb-4">
      <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#FEF2F2] text-[#C8102E]">
        <Icon className="h-5 w-5" />
      </span>
      <h2 className="font-heading text-xl font-semibold text-slate-900">{title}</h2>
    </div>
  );
}
